import React from 'react';
import Logo from './Logo';

/**
 * Simple footer with logo, copyright, and key links.
 */
const Footer: React.FC = () => {
  return (
    <footer
      className="py-10"
      style={{ borderTop: '1px solid var(--cv-border)' }}
    >
      <div className="w-full max-w-[1200px] mx-auto px-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          {/* Copyright */}
          <div
            className="flex items-center gap-2"
            style={{ fontSize: '13px', color: 'var(--cv-text-faint)' }}
          >
            <Logo size={18} />
            © 2026 CreatorVault. All rights reserved.
          </div>

          {/* Links */}
          <nav className="flex gap-6" aria-label="Footer navigation">
            {[
              { label: 'Pricing', href: '/pricing', external: true },
              { label: 'FAQ', href: '#faq', external: false },
              { label: 'Terms', href: '#', external: true },
              { label: 'Privacy', href: '#', external: true },
            ].map(({ label, href, external }) => (
              <a
                key={label}
                href={href}
                {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                style={{
                  fontSize: '13px',
                  color: 'var(--cv-text-faint)',
                  transition: 'color 180ms cubic-bezier(0.16, 1, 0.3, 1)',
                  textDecoration: 'none',
                }}
                onMouseEnter={(e) =>
                  ((e.currentTarget as HTMLAnchorElement).style.color = 'var(--cv-text-muted)')
                }
                onMouseLeave={(e) =>
                  ((e.currentTarget as HTMLAnchorElement).style.color = 'var(--cv-text-faint)')
                }
              >
                {label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
